export const GameGroupTypeEnum = {
    Generic: 'Generic',
    Sport: 'Sport',
    Lottery: 'Lottery',
    Racing: 'Racing',
};